import React, { useState, useEffect, useContext } from "react";
import EligibilityCheckbox from "../EligibilityCheckbox/EligibilityCheckbox";
import { findTandcQuestions, checkedTandcValue } from "./tandcHelper";
import { makeStyles } from "@material-ui/core/styles";

import { EWContext } from "../../../../context/EWContext";


const divTandcStyle = makeStyles(() => ({
  divStyle: {
    position: "sticky",
    background: "#FFFFFF",
    top: 5,
    bottom: 0,
    zIndex: 10,
    minWidth: "100%",
  },
  hrStyle: {
    marginLeft: "-25%",
    marginBottom: "10px",
    width: "150%",
    overflow: "hidden",
  },
}));

export default function TermsAndConditions(props) {

  const accountState = useContext(EWContext)[0];
  const divStyle = divTandcStyle();
  const { questions, answers, handlerCheckboxChange, tandcReaded, openTermsAndConditions } = props;
  const [tandcChecked, setTandcChecked] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    setTandcChecked(checkedTandcValue(answers));
  }, [answers]);

  useEffect(() => {
    tandcChecked ? setDisabled(false) : setDisabled(!tandcReaded);
  }, [tandcReaded, tandcChecked]);

  return (
    <div className={divStyle.divStyle}>
      <hr className={divStyle.hrStyle}></hr>
      <EligibilityCheckbox
        question={questions}
        name={"tandc"}
        label={findTandcQuestions(questions, accountState) || "I have read, understood and agree to the Terms and Conditions."}
        checked={tandcChecked}
        handlerCheckboxChange={handlerCheckboxChange}
        disabled={openTermsAndConditions ? disabled : false}
      />
    </div>
  )
}